import { Component } from '@angular/core';

@Component({
  selector: 'app-settlement-main',
  templateUrl: './settlement-main.component.html',
  styleUrls: ['./settlement-main.component.css']
})
export class SettlementMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
